<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div fxFlex="45">

    <mat-card *ngIf="customer" class="content-card">

      <mat-card-content>

        <div fxLayout="row">
          <div fxFlex="50">
            <h3>Address Confirmation / Change</h3>
          </div>
          <div fxFlex="50" class="text-center" style="text-align: right;padding-top: 10px;">
            <app-customer-badges *ngIf="customer" [compact]="true" [customer]="customer"></app-customer-badges>
          </div>
        </div>

        <div *ngFor="let field of fields" class="list-item" fxLayout="row">
          <app-content-row [entity]="customer" [field]="field"></app-content-row>
        </div>
      </mat-card-content>

      <mat-card-actions align="end">

        <button (click)="markAsVulnerable(customer)" [class.spinner]="isMarkingAsVulnerable" [disabled]="isMarkingAsVulnerable || customer.isVulnerable" class="mr-1"
                color="grey" mat-raised-button>
          🤕 Mark customer as vulnerable
        </button>

        <button (click)="sendAddressLink(customer)" [disabled]="isAddressDisabled(customer)" class="mr-1"
                color="blue" mat-raised-button>
          Change Address
        </button>
        <button (click)="gotoPrevCustomer()" [disabled]="!prevNext?.prev" color="primary" mat-raised-button>
          Previous
        </button>
        <button (click)="gotoNextCustomer()" [disabled]="!prevNext?.next" color="primary" mat-raised-button>
          Next
        </button>
      </mat-card-actions>

    </mat-card>

    <mat-card *ngIf="customer" class="content-card">

      <mat-card-content>

        <h3>Cards</h3>

        <mat-table [dataSource]="customer?.cards">
          <ng-container matColumnDef="token">
            <mat-header-cell *matHeaderCellDef> Token</mat-header-cell>
            <mat-cell *matCellDef="let card"> {{ card.token }}</mat-cell>
          </ng-container>

          <!-- Age Definition -->
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef> Status</mat-header-cell>
            <mat-cell *matCellDef="let card"> {{ card.statusName }}</mat-cell>
          </ng-container>

          <!-- Title Definition -->
          <ng-container matColumnDef="expiry">
            <mat-header-cell *matHeaderCellDef> Expiry</mat-header-cell>
            <mat-cell
              *matCellDef="let card"> {{ card.expireDate ? (card.expireDate.substring(5, 7) + "/" + card.expireDate.substring(2, 4)) : "-" }}
            </mat-cell>
          </ng-container>

          <!-- Header and Row Declarations -->
          <mat-header-row *matHeaderRowDef="['token', 'status', 'expiry']"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ['token', 'status', 'expiry']"></mat-row>
        </mat-table>

        <ng-container *ngIf="!customer?.cards?.length">
          <div style="text-align: center; padding: 5px;">
            <i>--- no cards ---</i>
          </div>
        </ng-container>
      </mat-card-content>

    </mat-card>

    <mat-card *ngIf="currentUserIsAdminOrManagerOrAgent()" class="content-card">

      <h3>Address</h3>

      <mat-card-content>
        <table class="list-table" style="word-wrap:break-word; table-layout: fixed;">
          <tr>
            <th style="text-align: left; width: 140px;"><label>Date</label></th>
            <th style="text-align: left;"><label>Type</label></th>
            <th style="text-align: left"><label>Status</label></th>
            <th style="text-align: left; width: 120px;"></th>
          </tr>



            <ng-container  *ngFor="let f of addressUploadFiles">
              <tr [class.noborderbottom]="true">
                <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
                <td><label>{{ getAddressUploadTypeText(f) }}</label></td>
                <td>
                  <app-tri-state-checkbox *ngIf="f.mailSentDate == null" [(ngModel)]="f.isSuccess"
                                          style="margin-right: 3px;">
                    <label *ngIf="f.isSuccess == true">Success</label>
                    <label *ngIf="f.isSuccess == false">Failed</label>
                    <label *ngIf="f.isSuccess == null">Pending</label>
                  </app-tri-state-checkbox>
                  <ng-container *ngIf="f.mailSentDate != null">
                    <label style="color: forestgreen;" *ngIf="f.isSuccess == true">Success</label>
                    <label style="color: red;" *ngIf="f.isSuccess == false">Failed</label>
                    <label *ngIf="f.isSuccess == null">Pending</label>
                  </ng-container>
                </td>

                <td style="padding-top: 5px;">
                  <button style="margin-right: 5px;" aria-label="download" color="accent" mat-mini-fab>
                    <mat-icon>cloud_download</mat-icon>
                  </button>
                  <button (click)="openFile(f.id)" aria-label="preview" color="primary" mat-mini-fab>
                    <mat-icon matSuffix>play_arrow</mat-icon>
                  </button>
                </td>

              </tr>
              <tr [class.noborderbottom]="f.comment" *ngIf="currentUserIsAdminOrManager()">
                <td colspan="4" style="padding-bottom: 5px;">
                  <div class="hover-blue" (click)="openFile(f.id)">
                    <label style="font-family: monospace; font-size: .85em">
                      <ng-container *ngIf="f.isSuccess == false">❌</ng-container>
                      <ng-container *ngIf="f.isSuccess == true">✅</ng-container>
                      <ng-container *ngIf="f.isSuccess == null">🖼️</ng-container>
                      {{ f.originalFileName }}
                    </label>
                  </div>

                </td>
              </tr>

              <ng-container *ngIf="f.comment">
                <tr>
                  <td colspan="4" style="border-top: none; font-size: .8em; ">
                    <div>
                      📑 {{f.comment}}
                    </div>
                    <div style="font-weight: bold; font-size: .9em; padding-left: 5px;font-family: monospace">
                      {{f.decisionUserInitials}} ({{f.decisionUserEmail}})
                    </div>
                  </td>

                </tr>
              </ng-container>

            </ng-container>
          </table>



        <div [hidden]="!showChangeAddress(addressUploadFiles)">
          <h4>Change address</h4>
          <form *ngIf="addressForm" [formGroup]="addressForm">
            <mat-form-field>
              <input formControlName="zipCode" matInput maxlength="50" placeholder="Postcode" required>
            </mat-form-field>
            <mat-form-field>
              <input formControlName="city" matInput maxlength="50" placeholder="City" required>
            </mat-form-field>
            <mat-form-field>
              <input formControlName="address" matInput maxlength="50" placeholder="Address" required>
            </mat-form-field>
            <mat-form-field>
              <mat-select formControlName="countryIsoCode" placeholder="Country" required>
                <mat-option *ngFor="let country of countries" [value]="country.isoCode">{{ country.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
      </mat-card-content>

      <mat-card-actions *ngIf="customer" align="end">
        <button (click)="save(newAddressUploadFiles)"
                [class.spinner]="isSaving"
                [disabled]="newAddressUploadFiles == null || newAddressUploadFiles.length <= 0 || isSaveAddressDisabled || isSaving"
                color="primary"
                mat-raised-button>Save and inform customer
        </button>
      </mat-card-actions>

    </mat-card>
  </div>

  <div fxFlex="55">

    <mat-card *ngIf="openUploadLinks" class="content-card">

      <mat-card-header>
        <mat-card-title>
          <h5>Open Upload Links</h5>
        </mat-card-title>
      </mat-card-header>

      <mat-card-content style="">
        <div *ngFor="let uploadLink of openUploadLinks">
          {{uploadLink.id}}:

          <ng-container *ngIf="uploadLink.typ == 1">IDV</ng-container>
          <ng-container *ngIf="uploadLink.typ == 2">Docs</ng-container>
          <ng-container *ngIf="uploadLink.typ == 3">Address Change</ng-container>
          <ng-container *ngIf="uploadLink.typ == 4">SOF Generic</ng-container>
          <ng-container *ngIf="uploadLink.typ == 5">SOF Single</ng-container>
          <ng-container *ngIf="uploadLink.typ == 6">Address Confirmation</ng-container>


          {{uploadLink.linkToken}} (exp {{uploadLink.expiryDate | date: "dd.MM.yyyy"}})
        </div>
      </mat-card-content>

    </mat-card>

    <mat-card *ngIf="customer" class="content-card">

      <mat-card-header>
        <mat-card-title>
          <h5 *ngIf="filename == null">Preview</h5>
          <h5 *ngIf="filename != null">{{ filename }}</h5>
          <mat-error *ngIf="errorMsg != null">{{ errorMsg }}</mat-error>
        </mat-card-title>
      </mat-card-header>

      <mat-card-content style="">
        <!--
        <div class="resp-container">
          <iframe class="resp-iframe" src="https://www.youtube.com/embed/dQw4w9WgXcQ" gesture="media"  allow="encrypted-media" allowfullscreen [hidden]="isFrameHidden" frameBorder="1" [src]="urlSafe"></iframe>
        </div>
        -->

        <iframe [hidden]="isFrameHidden" [src]="urlSafe" class="resp-iframe" frameBorder="1" height="1000" width="100%">
        </iframe>
        <img [hidden]="isImgHidden" [src]="urlSafe" style="width: 100%; height:auto;"/>
      </mat-card-content>

    </mat-card>
  </div>
</div>
